export default __webpack_public_path__ + "static/poster-c382065cb616e3088862e6ece18e331b.png";